import React from 'react'
import axios from "axios";
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from "yup";

function EditEvent() {
    let { id } = useParams();
    const [eventObject, setEventObject] = useState({});

    useEffect(() => {
        axios.get(`https://bntserver.bntfoundation.com/EventPut.php?id=${id}`).then((response) => {
            setEventObject(response.data);
        })
    }, [id])

    const onUpdate = async (data) => {
        try {
            const formData = new FormData();
            formData.append("id", data.id);
            formData.append("title", data.title);
            formData.append("desc", data.desc);
            formData.append("eventdate", data.eventdate);
            if (data.image) {
                formData.append("image", data.image);
            }

            await axios.put("https://bntserver.bntfoundation.com/EventPut.php", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            window.location.href = '/eventlist';
        } catch (error) {
            console.error("Error updating event:", error);
        }
    };

    const validation = Yup.object().shape({
        title: Yup.string().required("Title is required"),
        desc: Yup.string().required("Description is required"),
        eventdate: Yup.date().required("Event date is required"),
    })

    return (
        <div>
            <h2>Edit Event</h2>
            <Formik
                initialValues={eventObject}
                onSubmit={onUpdate}
                enableReinitialize={true}
                validationSchema={validation}
            >
                {({ values, setFieldValue, isSubmitting }) => (
                    <Form>
                        <div className="form-horizontal">
                            <div className="form-group">
                                <label className="control-label col-md-2">Title</label>
                                <div className="col-md-10">
                                    <ErrorMessage name="title" component="span" className='text-danger' />
                                    <Field
                                        name="title"
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="control-label col-md-2">Description</label>
                                <div className="col-md-10">
                                    <ErrorMessage name="desc" component="span" className='text-danger' />
                                    <Field
                                        name="desc"
                                        className="form-control"
                                        as="textarea"
                                        rows="4"
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="control-label col-md-2">Event Image</label>
                                <div className="col-md-10">
                                    {eventObject.image && (
                                        <div className="mb-2">
                                            <img
                                                src={`https://bntserver.bntfoundation.com/${eventObject.image}`}
                                                alt="Current event"
                                                style={{ maxWidth: '200px' }}
                                            />
                                        </div>
                                    )}
                                    <input
                                        type="file"
                                        onChange={(event) => {
                                            setFieldValue("image", event.target.files[0]);
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="control-label col-md-2">Event Date</label>
                                <div className="col-md-10">
                                    <ErrorMessage name="eventdate" component="span" className='text-danger' />
                                    <Field
                                        type="date"
                                        name="eventdate"
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="col-md-offset-2 col-md-10">
                                    <input
                                        type="submit"
                                        disabled={isSubmitting}
                                        value="Update"
                                        className="btn btn-secondary"
                                    />
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default EditEvent; 